import React from 'react';
import { siteConfig } from '../../data/config';
export function SiteFooter() {
  const l = siteConfig.legalLinks;
  const links = [{
    label: 'Terms & Conditions',
    href: l.terms
  }, {
    label: 'Privacy Policy',
    href: l.privacy
  }, {
    label: 'Refund Policy',
    href: l.refund
  }, {
    label: 'Contact',
    href: l.contact
  }].filter(x => x.href);
  return <footer id="site-footer" className="border-t border-white/10 bg-charcoal text-ivory" data-id="element-183" data-mp="1kde50l6zcfy6">
      <div className="mx-auto grid max-w-site gap-8 px-5 py-14 md:grid-cols-2 md:px-8" data-id="element-184" data-mp="nnep25oi2f5k">
        <div data-id="element-185" data-mp="rrcoyilnftzo">
          <p className="font-display text-[15px] font-bold uppercase tracking-[0.16em]" data-id="element-186" data-mp="roqdi7vn0uc6">Diesel Fault Atlas</p>
          <p className="mt-2 text-[15px] text-mist" data-id="element-187" data-mp="11gw6nkxmlhsy">The Visual Troubleshooting Guide for Diesel Technicians</p>
          <p className="mt-1 text-[15px] italic text-copper" data-id="element-188" data-mp="41ryzfr2vwgw">Trace the symptom. Test the cause.</p>
        </div>
        <div className="md:text-right" data-id="element-189" data-mp="8ztk0682e5v0">
          {links.length > 0 && <ul className="mb-4 flex flex-wrap gap-x-6 gap-y-2 text-[15px] md:justify-end" data-id="element-190" data-mp="an3sqvmajxp4">
              {links.map(x => <li key={x.label} data-id="element-191" data-mp="6l9xj2uv7lwc">
                  <a href={x.href} className="text-ivory underline-offset-4 transition-colors duration-150 ease-out hover:text-copper hover:underline" data-id="element-192" data-mp="6mbjw3hbzutd">
                    {x.label}
                  </a>
                </li>)}
            </ul>}
          <p className="text-[14px] leading-relaxed text-mist md:ml-auto md:max-w-[460px]" data-id="element-193" data-mp="3o32vgb44i3gv">
            Diesel Fault Atlas is an educational reference for organizing diagnostic work. Always confirm specifications, values, procedures, and
            safety requirements in the manufacturer’s documentation for the specific vehicle or engine.
          </p>
          <p className="mt-3 text-[13px] text-mist" data-id="element-194" data-mp="3a4l9ahtv8z12">© {new Date().getFullYear()} Diesel Fault Atlas</p>
        </div>
      </div>
    </footer>;
}